<header class="nav-shell" role="banner">
  <div class="nav-shell__inner">
    @if (responsive.isMobile) {
      <button
        type="button"
        class="nav-shell__icon-btn"
        [attr.aria-label]="'nav.open menu' | translate"
        [attr.aria-expanded]="drawerOpen"
        aria-controls="nav-drawer"
        (click)="openDrawer()"
      >
        <ut-icon name="menu" [size]="22"></ut-icon>
      </button>
    }

    <div class="nav-shell__brand">
      @if (organization?.menuLogo) {
        <app-s3-img [uuid]="organization.menuLogo" height="28px" width="auto" />
      } @else if (title) {
        <span class="nav-shell__title">{{ title | translate }}</span>
      }
    </div>

    @if (desktop && menuItems.length > 0) {
      <nav
        class="nav-shell__primary"
        [attr.aria-label]="'nav.primary' | translate"
      >
        @for (menuItem of menuItems; track menuItem.url) {
          <a
            class="nav-shell__link"
            routerLinkActive="is-active"
            #rla="routerLinkActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [routerLink]="[menuItem.url]"
          >
            @if (menuItem.icon) {
              <ut-icon [name]="menuItem.icon" [size]="18"></ut-icon>
            }
            <span>{{ menuItem.title | translate }}</span>
          </a>
        }
      </nav>
    }

    <div class="nav-shell__actions">
      <app-student-credits *isStudent></app-student-credits>

      <button
        *isStudent
        type="button"
        class="nav-shell__icon-btn"
        [attr.aria-label]="'nav.shop' | translate"
        (click)="nav.studentShop()"
      >
        <ut-icon name="shopping-bag" [size]="20"></ut-icon>
      </button>

      @if (responsive.isMobile) {
        <button
          type="button"
          class="nav-shell__icon-btn"
          [attr.aria-label]="'nav.home' | translate"
          (click)="nav.defaultPublicPage()"
        >
          <ut-icon name="home" [size]="20"></ut-icon>
        </button>
      }

      <app-general-chat-indicator></app-general-chat-indicator>

      <button
        type="button"
        class="nav-shell__avatar-btn"
        [attr.aria-label]="'nav.profile' | translate"
        (click)="nav.profile(user)"
      >
        <ut-avatar
          size="sm"
          [name]="user?.fullName || ''"
        ></ut-avatar>
      </button>
    </div>
  </div>
</header>

@if (responsive.isMobile) {
  <div
    class="nav-drawer-backdrop"
    [class.is-open]="drawerOpen"
    (click)="closeDrawer()"
    aria-hidden="true"
  ></div>

  <aside
    id="nav-drawer"
    class="nav-drawer"
    [class.is-open]="drawerOpen"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'nav.primary' | translate"
    [attr.aria-hidden]="!drawerOpen"
    [attr.inert]="drawerOpen ? null : ''"
  >
    <div class="nav-drawer__header">
      <div class="nav-drawer__user">
        <ut-avatar
          size="md"
          [name]="user?.fullName || ''"
        ></ut-avatar>
        <div class="nav-drawer__user-info">
          <div class="nav-drawer__user-name">
            {{ user?.fullName || ('nav.profile' | translate) }}
          </div>
          @if (user?.email) {
            <div class="nav-drawer__user-email">{{ user.email }}</div>
          }
        </div>
      </div>
      <button
        type="button"
        class="nav-shell__icon-btn"
        [attr.aria-label]="'nav.close menu' | translate"
        (click)="closeDrawer()"
      >
        <ut-icon name="x" [size]="20"></ut-icon>
      </button>
    </div>

    <nav
      class="nav-drawer__nav"
      [attr.aria-label]="'nav.primary' | translate"
    >
      @for (menuItem of menuItems; track menuItem.url) {
        <a
          class="nav-drawer__link"
          routerLinkActive="is-active"
          #rla="routerLinkActive"
          [attr.aria-current]="rla.isActive ? 'page' : null"
          [routerLink]="[menuItem.url]"
          (click)="closeDrawer()"
        >
          @if (menuItem.icon) {
            <ut-icon [name]="menuItem.icon" [size]="20"></ut-icon>
          } @else {
            <span class="nav-drawer__link-bullet" aria-hidden="true"></span>
          }
          <span>{{ menuItem.title | translate }}</span>
        </a>
      }
    </nav>

    <div class="nav-drawer__footer">
      <button
        type="button"
        class="nav-drawer__link"
        (click)="closeDrawer(); nav.profile(user)"
      >
        <ut-icon name="user" [size]="20"></ut-icon>
        <span>{{ 'nav.profile' | translate }}</span>
      </button>
      <button
        type="button"
        class="nav-drawer__link"
        (click)="closeDrawer(); nav.defaultPublicPage()"
      >
        <ut-icon name="home" [size]="20"></ut-icon>
        <span>{{ 'nav.home' | translate }}</span>
      </button>
    </div>
  </aside>
}

<div class="content-container">
  <router-outlet></router-outlet>
</div>
